import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { freezeReturnPath } from './freezeLock';
import { useSubscriptionFreeze } from './SubscriptionFreezeContext';

/**
 * A paused plan is resumed, never bought again, and billing refuses changes while a pause is open: a purchase
 * surface opened then is closed and the customer taken to the pause. Returns whether a pause is open, so the
 * caller keeps the surface from showing meanwhile.
 */
export function usePausedPurchaseRedirect(open: boolean, close: () => void) {
  const { freeze } = useSubscriptionFreeze();
  const navigate = useNavigate();
  const latestClose = useRef(close);
  latestClose.current = close;

  useEffect(() => {
    if (!freeze || !open) return;
    latestClose.current();
    navigate(freezeReturnPath(freeze));
  }, [freeze, open, navigate]);

  return Boolean(freeze);
}
